import { render } from "./ModalObservar.vue?vue&type=template&id=42f0aa4e&scoped=true"
import script from "./ModalObservar.vue?vue&type=script&lang=js"
export * from "./ModalObservar.vue?vue&type=script&lang=js"

import "./ModalObservar.vue?vue&type=style&index=0&id=42f0aa4e&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f0aa4e"]])

export default __exports__